import {
  trigger,
  state,
  style,
  transition,
  query,
  animateChild,
} from '@angular/animations';

export const widenContainer = trigger('widenContainer', [
  state(
    'open',
    style({
      'border-style': 'solid',
      display: 'block',
    })
  ),
  state(
    'closed',
    style({
      'border-style': 'none',
      display: 'none',
      overflow: 'hidden',
    })
  ),
  transition('open => closed', [query('@widen', animateChild())]),
]);
